"use client";

import Image from "next/image";
import Link from "next/link";
import { Flame } from "lucide-react";

interface SoftDealsProps {
  deals: any[];
  subdomain: string;
  resolveImg: (url: string | null | undefined, fallback: string) => string;
}

export default function SoftDeals({ deals, subdomain, resolveImg }: SoftDealsProps) {
  if (!deals || deals.length === 0) return null;

  return (
    <section id="deals" className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="flex items-center gap-2.5 mb-6">
        <div className="w-9 h-9 rounded-2xl bg-amber-500/10 text-amber-500 flex items-center justify-center">
          <Flame className="w-5 h-5 fill-amber-500" />
        </div>
        <div>
          <h2 className="text-xl sm:text-2xl font-black text-slate-900">Deals of the Day</h2>
          <p className="text-xs text-slate-400">Exclusive flash pricing for today only</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {deals.map((item) => {
          // 🌟 প্রতিটি প্রোডাক্টের নিজস্ব সঠিক ইমেজ প্রপার্টি চেক করা হচ্ছে
          const rawProductImg = item.image_url || item.image || item.primary_image;
          const itemImg = resolveImg(
            rawProductImg,
            "https://images.unsplash.com/photo-1542838132-92c53300491e?w=500"
          );

          return (
            <div
              key={item.id}
              className="bg-white rounded-3xl p-5 shadow-[8px_8px_18px_#dce5ef,-8px_-8px_18px_#ffffff] border border-white/80 space-y-3 hover:-translate-y-1 transition-transform"
            >
              <div className="relative w-full h-44 rounded-2xl overflow-hidden bg-slate-50">
                <Image
                  src={itemImg}
                  alt={item.name}
                  fill
                  unoptimized
                  className="object-cover"
                />
                <span className="absolute top-2.5 left-2.5 px-2.5 py-1 rounded-full bg-amber-500 text-white text-[9px] font-black uppercase">
                  Hot Deal
                </span>
              </div>
              <h3 className="text-xs font-bold text-slate-900 truncate">{item.name}</h3>
              <div className="flex items-center justify-between">
                <span className="text-sm font-black text-blue-600 font-mono">
                  ৳{Number(item.price || 0).toLocaleString()}
                </span>
                <Link
                  href={`/products/${item.slug || item.id}`}
                  className="text-xs font-bold text-blue-600 hover:underline"
                >
                  View Details →
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}